import { type Layer, type NormalLayerSpec, defineNormalLayer } from '../../../core/layer';
import DEFINE from '../../../util/DEFINE';
import { type Config as TimeLineConfig } from '../../../ui/timeLine/TimeLine';
import { type CustomEvent } from './multiTable';

type Event = {
  type: string;
  data?: CustomEvent;
};

const visInfo: Layer['visInfo'] = {
  id: 'timeLine',
  name_en: 'timeLine',
  name_zh: '新时间列表',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  /** 保证和 Spec.encoding 字段一致 */
  parameters: {
    time: {
      itemType: [DEFINE.DATE],
      category: DEFINE.SINGLE
    },
    title: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE
    },
    label: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE
    },
    url: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE,
      optional: true
    },
    importance: {
      itemType: [DEFINE.NUMBER],
      category: DEFINE.SINGLE
    }
  }
};

export interface Spec extends NormalLayerSpec {
  /** 使用的数据集索引，默认为 0 */
  dataIndex?: number;
  encoding: {
    time: string;
    title: string;
    label: string;
    url?: string;
    importance: number;
  };
  maxHeight?: number;
  width?: number;
  customEvent?: (event: Event) => void;
}

export const layer = defineNormalLayer<Spec>({
  type: visInfo.id,
  visInfo,
  render(api, spec, $dom) {
    const { data: dataArray, ui, token } = api;
    const {
      dataIndex = 0,
      encoding: { time, title, label, url, importance },
      maxHeight = 520,
      width = 570,
      customEvent
    } = spec;
    const timeLineTheme = token?.dvTimeLine;
    const data = dataArray[dataIndex].values;
    const transformData: TimeLineConfig[] = [];
    data.forEach(item => {
      let transformLabel = item[label];
      if (typeof item[label] === 'string') {
        transformLabel = (item[label] as string).split(',');
      }
      transformData.push({
        time: item[time] as TimeLineConfig['time'],
        title: item[title] as TimeLineConfig['title'],
        label: transformLabel as unknown as TimeLineConfig['label'],
        url: (!url ? undefined : item[url]) as TimeLineConfig['url'],
        importance: item[importance] as TimeLineConfig['importance']
      });
    });

    // * -------------------------- TimeLine
    const timeLineIns = new ui.TimeLine($dom, {
      config: transformData,
      // 这里减去的32是筛选框的高度，虽然内部筛选框和时间列表是两个组件的拼接，但是对于业务方来说这是一个组件，传入的高度定义的是时间列表的高度
      // maxHeight: optionArr.length ? maxHeight - 36 : maxHeight,
      maxHeight,
      width,
      themeConfig: timeLineTheme
    });

    timeLineIns.on('change:selected', event => {
      if (customEvent) {
        customEvent(event);
      }
    });

    return () => {
      // eslint-disable-next-line no-param-reassign
      $dom.innerHTML = '';
      timeLineIns?.destroy?.();
      // selectIns?.destroy?.();
    };
  }
});
